import React, { useEffect, useState } from 'react'
import UserHeader from '../../UserHeader'
import { Button, Card, CardContent, CardHeader, MenuItem, TextField } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import { professionalDetailEditSchema } from '../../../ValidationSchema'
import { editProfessionalDetailData, getAllIncome, getCity, getCountry, getEducation, getOccupation, getState } from '../../../../asiosConfig'
import Popup from '../../../Popup';

export const CareerEdit = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const professionalData = location.state?.userProfileData || {};
  const [education, setEducation] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [income, setIncome] = useState([]);
  const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

  const handleClosePopup = () => {
    setPopupData({ ...popupData, open: false });
  };

  const formik = useFormik({
    initialValues: {
      education: professionalData.educationIDS || '',
      educationDetail: professionalData.educationDetail || '',
      occupation: professionalData.occupationIDS || '',
      occupationDetail: professionalData.occupationDetail || '',
      income: professionalData.income || '',
      residingCountry: professionalData.residingCountryIDS || '',
      residingState: professionalData.residingStateIDS || '',
      residingCity: professionalData.residingCityIDS || '',
      // token: localStorage.getItem('token'),
      user_id: localStorage.getItem('user_id'),
    },
    validationSchema: professionalDetailEditSchema,
    onSubmit: async (values, { isSubmitting }) => {
      try {

        const response = await editProfessionalDetailData(values);
        if (response.status === 200 || response.status === 201) {
          setPopupData({ open: true, type: 'success', message: response.data.message });
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        } else {
          setPopupData({ open: true, type: 'error', message: 'Failed to update Professional Details' });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      } finally {
        isSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchoption = async () => {
      try {
        const [educationResponse, occupationResponse, countryResponse, incomeResponse] = await Promise.all([
          getEducation(),
          getOccupation(),
          getCountry(),
          getAllIncome(),
        ]);
        setCountries(countryResponse.data.data);
        setEducation(educationResponse.data.data);
        setOccupation(occupationResponse.data.data);
        setIncome(incomeResponse.data.data);
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    }
    fetchoption();
  }, []);
  useEffect(() => {
    const fetchStates = async () => {
      if (formik.values.residingCountry) {
        try {
          const response = await getState(formik.values.residingCountry);
          if (response.status === 200 || response.status === 201) {
            setStates(response.data.data);
          } else {
            setPopupData({ open: true, type: 'error', message: 'Failed to fetch states' });
          }
        } catch (error) {
          setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
        }
      }
    };
    fetchStates();
  }, [formik.values.residingCountry]);

  useEffect(() => {
    const fetchCities = async () => {
      if (formik.values.residingState) {
        try {
          const response = await getCity(formik.values.residingState);
          if (response.status === 200 || response.status === 201) {
            setCities(response.data.data);
          } else {
            setPopupData({ open: true, type: 'error', message: 'Failed to fetch cities' });
          }
        } catch (error) {
          setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
        }
      }
    };
    fetchCities();
  }, [formik.values.residingState]);
  return (
    <div className="col-lg-9 col-md-10 col-12">
      <Card className='editProfileBlock mt-3'>
        <CardHeader
          avatar={
            <ArrowBackIcon sx={{ color: '#FF8008', cursor: 'pointer' }} onClick={() => navigate(-1)} />
          }
          title="Education & Profession"
          subheader="Update your Education & Profession to get suitable matches"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }} />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label='Education'
                  variant='outlined'
                  className='mb-3'
                  name='education'
                  value={formik.values.education}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.education && Boolean(formik.errors.education)}
                  helperText={formik.touched.education && formik.errors.education}
                >
                  <MenuItem value=''>Select Highest Education</MenuItem>
                  {education.map((item) => (
                    <MenuItem key={item.id} value={item.id}>{item.education}</MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Education Detail"
                  variant="outlined"
                  className="mb-3"
                  name='educationDetail'
                  value={formik.values.educationDetail}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.educationDetail && Boolean(formik.errors.educationDetail)}
                  helperText={formik.touched.educationDetail && formik.errors.educationDetail}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Profession"
                  variant="outlined"
                  className="mb-3"
                  name='occupation'
                  value={formik.values.occupation}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.occupation && Boolean(formik.errors.occupation)}
                  helperText={formik.touched.occupation && formik.errors.occupation}
                >
                  <MenuItem value=''>Select Profession</MenuItem>
                  {occupation.map((item) => (
                    <MenuItem key={item.id} value={item.id}>{item.occupation}</MenuItem>
                  ))}

                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Profession Detail"
                  variant="outlined"
                  className="mb-3"
                  value={formik.values.occupationDetail}
                  name='occupationDetail'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.occupationDetail && Boolean(formik.errors.occupationDetail)}
                  helperText={formik.touched.occupationDetail && formik.errors.occupationDetail}
                  InputProps={{
                    style: { textAlign: 'center' }, // For older Material-UI versions, does not work in all cases
                    inputProps: {
                      style: { textAlign: 'center' }, // Center-aligns text in the input field
                    },
                  }}
                />
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Income"
                  variant="outlined"
                  className="mb-3"
                  value={formik.values.income}
                  name='income'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.income && Boolean(formik.errors.income)}
                  helperText={formik.touched.income && formik.errors.income}
                >
                  <MenuItem value=''>Select Income</MenuItem>
                  {income.map((item) => (
                    <MenuItem key={item.tbl_income_id} value={item.tbl_income_id}>{item.income_type}</MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Residing Country"
                  variant="outlined"
                  className="mb-3"
                  value={formik.values.residingCountry}
                  name='residingCountry'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.residingCountry && Boolean(formik.errors.residingCountry)}
                  helperText={formik.touched.residingCountry && formik.errors.residingCountry}
                >
                  <MenuItem value="">Select Country</MenuItem>
                  {countries.map((country, index) => (
                    <MenuItem key={index} value={country.id}>
                      {country.country}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Residing State"
                  variant="outlined"
                  className="mb-3"
                  value={formik.values.residingState}
                  name='residingState'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.residingState && Boolean(formik.errors.residingState)}
                  helperText={formik.touched.residingState && formik.errors.residingState}
                >
                  <MenuItem value="">Select State</MenuItem>
                  {states.map((state, index) => (
                    <MenuItem key={index} value={state.id}>
                      {state.state}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Residing City"
                  variant="outlined"
                  className="mb-3"
                  value={formik.values.residingCity}
                  name='residingCity'
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.residingCity && Boolean(formik.errors.residingCity)}
                  helperText={formik.touched.residingCity && formik.errors.residingCity}
                >
                  <MenuItem value="">Select City</MenuItem>
                  {cities.map((city, index) => (
                    <MenuItem key={index} value={city.id}>
                      {city.city}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
            </div>
            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
              {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
            {/* </div> */}
          </form>
        </CardContent>
      </Card>

      <Popup
        open={popupData.open}
        type={popupData.type}
        message={popupData.message}
        onClose={handleClosePopup}
      />
    </div >
  );
};
